import { useDashboard, useOwnerPortalContact, useTeam } from '@vrplatform/data';
import { hasValue } from '@vrplatform/utils';
import { whereListings } from '@vrplatform/ui-common';
import { useMemo } from 'react';
import { useListingFilter } from './ListingFilter';

export function useWhereListings(opts: {
  filterByAutomationId: string | undefined;
}) {
  const [{ isGL: GL }] = useTeam();
  const filter = useFormattedListingFilter();

  const { contactId: ownerPortalContactId } = useOwnerPortalContact();

  const filterByAutomationId = opts?.filterByAutomationId;

  return useMemo(() => {
    return whereListings({
      ...filter,
      ownerPortalContactId,
      disabledByAutomationId:
        filterByAutomationId || filter.disabledByAutomationId,
      GL,
    });
  }, [filter, ownerPortalContactId, filterByAutomationId, GL]);
}

export function useFormattedListingFilter() {
  const [{ id: teamId }] = useTeam();
  const [dashboard] = useDashboard();

  const { filter } = useListingFilter();

  return useMemo(
    () => ({
      dashboard,
      search: filter.search?.trim(),
      tenantId: teamId,
      status: filter.status as any,
      ownerIds: filter.ownerIds,
      disabledByAutomationId: filter.automationIds?.filter(hasValue),
      collectionId: filter.collectionId,
      pmsConnectionId: filter.pmsConnectionId,
    }),
    [filter, teamId, dashboard]
  );
}
